import { FieldErrors } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../ChallengeAdmin'

/**
 * Helper to get field name with prefix for nested form fields.
 * Used for goals that can be nested (e.g., 'goals.team', 'goals.group.categoryId').
 */
export const getFieldName = (fieldName: string, fieldPrefix?: string): string => {
  return fieldPrefix ? `${fieldPrefix}.${fieldName}` : fieldName
}

/**
 * Helper to safely access nested field errors from react-hook-form.
 * Handles dot-notation paths like 'goals.team.totalGoal'.
 */
export const getFieldError = (fieldName: string, fieldPrefix: string, errors: FieldErrors<FormData>) => {
  const fullPath = getFieldName(fieldName, fieldPrefix)
  const pathParts = fullPath.split('.')
  let error: any = errors
  for (const part of pathParts) {
    if (error && typeof error === 'object') {
      error = error[part]
    } else {
      return undefined
    }
  }
  return error
}

/**
 * Helper to get error message text from react-hook-form error object.
 * React-hook-form doesn't always provide default messages, so we generate them based on error type.
 */
export const getErrorMessage = (error: any): string | undefined => {
  if (!error) return undefined

  // If there's a custom message, use it
  if (error.message) return error.message

  // Otherwise, generate message based on error type
  switch (error.type) {
    case 'required':
      return t`This field is required`
    case 'min':
      return t`Value is too small`
    case 'max':
      return t`Value is too large`
    default:
      return t`Invalid value`
  }
}
